import { useRef, useState } from 'react';
import { ReactComponent as EditSvg } from '../../../../assets/svg/edit.svg';
import { ReactComponent as CloseSvg } from '../../../../assets/svg/closeCircle.svg';
import { ReactComponent as LoadingSvg } from '../../../../assets/svg/loading-half-status.svg';
import { TrashIcon } from '@heroicons/react/20/solid';
import LogItem from './logItem';
import UpdateDialog from './updateDialog';
import request from '../../../../lib/request';

const MeasurementLogBook = ({ tableData, openCreateDialog, logs, refresh }) => {
  const bottomDialogRef = useRef(null);
  const updateDialogRef = useRef(null);

  const [selectedLog, setSelectedLog] = useState({});
  const [loading, setLoading] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const handleDelete = async () => {
    try {
      if (!window.confirm('Are you sure you want to delete this item?')) {
        return;
      }

      setLoading(true);

      await request.delete(`/log/measurement/${selectedLog.id}`);

      await refresh();
      closeBottomDialog();
    } catch (error) {
      console.error('Error deleting log:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectLog = (index) => () => {
    setSelectedLog(logs[index]);
    openBottomDialog();
  };

  const openBottomDialog = () => {
    if (bottomDialogRef.current) {
      bottomDialogRef.current.showModal();
    }
  };

  const closeBottomDialog = () => {
    if (bottomDialogRef.current) {
      bottomDialogRef.current.close();
    }
  };

  const openUpdateDialog = () => {
    if (updateDialogRef.current) {
      setIsDialogOpen(true);
      updateDialogRef.current.showModal();
      closeBottomDialog();
    }
  };

  const closeUpdateDialog = () => {
    if (updateDialogRef.current) {
      setIsDialogOpen(false);
      updateDialogRef.current.close();
    }
  };

  return (
    <div className='space-y-2'>
      <div className='flex justify-between items-center'>
        <div className='font-bold text-white'>Log Book</div>
        <button
          className='bg-tertiary rounded-full size-8 text-white'
          onClick={openCreateDialog}
        >
          +
        </button>
        <UpdateDialog
          dialogRef={updateDialogRef}
          closeDialog={closeUpdateDialog}
          isDialogOpen={isDialogOpen}
          log={selectedLog}
          refresh={refresh}
        />
      </div>
      <div className='space-y-4'>
        {tableData.map((item, i) => (
          <LogItem
            key={i}
            date={item.date}
            waistHips={item.waistHips}
            armThigh={item.armThigh}
            onClick={handleSelectLog(i)}
          />
        ))}
      </div>

      <dialog
        ref={bottomDialogRef}
        className='w-full h-full max-w-lg max-h-full bg-transparent'
        onCancel={closeBottomDialog}
      >
        <div
          className={`bg-secondary fixed bottom-0 w-full max-w-lg rounded-t-3xl px-3 py-6 text-white`}
        >
          <div className='mb-4 flex justify-end'>
            <CloseSvg
              className='size-5'
              onClick={closeBottomDialog}
            />
          </div>
          <div className='text-sm space-y-4'>
            <button
              className='px-3 py-2 flex items-center gap-2'
              onClick={openUpdateDialog}
              disabled={loading}
            >
              <EditSvg className='size-5 opacity-40' />
              Edit the log
            </button>
            <button
              className='px-3 py-2 flex items-center gap-2'
              disabled={loading}
              onClick={handleDelete}
            >
              <TrashIcon className='size-5 opacity-40' />
              Delete the log
            </button>
          </div>
          {loading && (
            <div className='absolute animate-bounce inset-x-0 top-4 flex justify-center items-center'>
              <LoadingSvg className='animate-spin' />
            </div>
          )}
        </div>
      </dialog>
    </div>
  );
};

export default MeasurementLogBook;
